import { render, staticRenderFns } from "./PartnerNationTab.vue?vue&type=template&id=28ea6d08"
import script from "./PartnerNationTab.vue?vue&type=script&lang=js"
export * from "./PartnerNationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports